import homeTemplate from './home.html';

class HomeController {
  static $inject = ['$state', '$timeout', 'AuthService', 'Timesheet'];

  constructor(
    private $state,
    private $timeout,
    private AuthService,
    private Timesheet,
  ) { }

  $onInit() {
    this.$timeout(() => {
      if (this.AuthService.isAuthenticated()) {
        this.Timesheet.gotoTimesheet();
      } else {
        this.$state.go('login');
      }
    }, 1000);
  }
}

export const HomeComponent = {
  template: homeTemplate,
  controller: HomeController
};
